/* eslint-disable no-undef */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Switch from '@material-ui/core/Switch';
import { ContextMenuTrigger } from 'react-contextmenu';

import { ConnectorDialog } from '../dialog';
import { Shapes } from '../shapes';
import GRID_SVG from '../../../images/grid.svg';
import DeleteSvg from '../../../images/delete.svg';
import { CustomMenuItem } from '../../reuseable';
import { makeAConnection } from '../../../util';

import 'styles/flowchart.scss';

const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const BlueSwitch = withStyles({
  switchBase: {
    color: '#87cefa',
    '&$checked': {
      color: '#87cefa',
    },
    '&$checked + $track': {
      backgroundColor: '#87cefa',
    },
  },
  checked: {},
  track: {},
})(Switch);

export class FlowChart extends Component {
  state = {
    expanded: true, grid: true, currentEleId: '', zoomValue: 1,
  };


  componentDidMount() {
    $(() => {
      $('#shapesWrapper').on('contextmenu', 'div', (e) => {
        e.preventDefault();
        if (e.target.id.indexOf('connection') >= 0) {
          this.setState({ currentEleId: e.target.id });
        } else {
          this.setState({ currentEleId: '' });
        }
      });
    });
  }

  stepText = (value) => value;

  handleZoom = (e, zoomValue) => {
    const shapesWrapper = document.getElementById('shapesWrapper');
    if (shapesWrapper) {
      shapesWrapper.style.transform = `scale(${zoomValue})`;
      shapesWrapper.style.transformOrigin = '50% 50%';
      this.setState({ zoomValue });
    }
  }

  toggleExpansionPanel = () => {
    const { expanded } = this.state;
    this.setState({ expanded: !expanded });
  }

  toggleGrid = (e) => {
    this.setState({ grid: e.target.checked });
  }

  delete = () => {
    const { currentEleId } = this.state;
    document.getElementById(currentEleId).remove();
  }

  toggleOpen = (data) => {
    const { open, currentEleId } = this.state;
    if (open && data && currentEleId) {
      makeAConnection(null, data, currentEleId);
    }
    this.setState((state) => {
      const { open } = state;
      return { open: !open };
    });
  }

  render() {
    const {
      flowchartData, styleObject, connectFrom, removeShape,
      circleOnClick, connectorSettings, currentActiveCircle,
      connectHandler, connectionUpdater,resetState
    } = this.props;
    const {
      expanded, grid, currentEleId, zoomValue, open,
    } = this.state;
    const menuList = [{ label: 'Delete', onClick: this.delete }, { label: 'Setting', onClick: this.toggleOpen }];
    return (
      <div className="flowchart">
        {
          open && (
            <ConnectorDialog
              open={open}
              close={this.toggleOpen}
              connectorSettings={connectorSettings}
            />
          )
        }

        <div className="toolWrapper">
          <ExpansionPanel
            expanded={expanded}
            className={`expansionPanel ${expanded ? '' : 'hide'}`}
          >
            <ExpansionPanelSummary
              expandIcon={(
                <ExpandMoreIcon
                  onClick={this.toggleExpansionPanel}
                  className={`${expanded ? '' : 'rotateRight'}`}
                />
              )}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div 
                className="delete-icon"
                style={{ backgroundImage: `url(${DeleteSvg})` }}
                onClick={resetState}
              />
              {expanded && (
                <div className="toggleGridWrapper">
                  <Typography id="discrete-slider" gutterBottom>
                    Toggle Grid
                  </Typography>
                  <BlueSwitch
                    checked={grid}
                    onChange={this.toggleGrid}
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </div>
              )}
              {expanded && (
                <div className="zoomWrapper">
                  <Typography id="discrete-slider" gutterBottom>
                    Zoom
                  </Typography>
                  <PrettoSlider
                    defaultValue={zoomValue}
                    getAriaValueText={this.stepText}
                    aria-labelledby="discrete-slider"
                    valueLabelDisplay="auto"
                    step={0.1}
                    min={0.1}
                    max={2}
                    className="slider"
                    onChange={this.handleZoom}
                  />
                </div>
              )}

            </ExpansionPanelSummary>
          </ExpansionPanel>
        </div>
        <div
          id="zoomingArea"
          style={{ backgroundImage: `url(${grid ? GRID_SVG : ''})` }}
          onScroll={connectionUpdater}
        >
          <ContextMenuTrigger id="contextMenu" disable={!currentEleId}>
            <div
              id="shapesWrapper"
              className="shapesWrapper"
            >
              {flowchartData.map(({
                shapeName, text, start, activeCircleIndex, id,
              }, index) => {
                const { Shape } = Shapes.find((obj) => obj.shapeName === shapeName);
                return (
                  <Shape
                    styleObject={styleObject}
                    key={id}
                    id={id}
                    text={ReactHtmlParser(text)}
                    removeShape={() => { removeShape(index); }}
                    start={start}
                    activeCircleIndex={activeCircleIndex}
                    connectHandler={connectHandler}
                    connectFrom={connectFrom}
                    currentActiveCircle={currentActiveCircle}
                    connectionUpdater={connectionUpdater}
                    circleOnClick={
                      (activeCircleIndex, position) => {
                        circleOnClick(index, activeCircleIndex, position);
                      }
                    }
                  />
                );
              })}
            </div>
          </ContextMenuTrigger>
        </div>
        {CustomMenuItem(menuList)}
      </div>
    );
  }
}

FlowChart.propTypes = {
  flowchartData: PropTypes.arrayOf(Object).isRequired,
  styleObject: PropTypes.instanceOf(Object).isRequired,
  removeShape: PropTypes.func.isRequired,
  circleOnClick: PropTypes.func.isRequired,
  connectHandler: PropTypes.func.isRequired,
  connectionUpdater: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
  connectFrom: PropTypes.string.isRequired,
  connectorSettings: PropTypes.instanceOf(Object).isRequired,
  currentActiveCircle: PropTypes.string,
};
FlowChart.defaultProps = {
  currentActiveCircle: '',
};
